





import {WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {defineComponent} from "@vue/composition-api"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {getLocationCaption} from "@/data/sources/appraisal"
import {executeQuery} from "@/data/repos/query";

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Custom(),
    widget: "ComplianceElementsWithNoLocations",
    title: "Compliance Elements With No Locations",
    cType: "text",
    w: 2,
    h: 2,
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

async function dataFetcher(params: any) {
  const locationId = parseInt(params.locationId && params.locationId.value || "10")
  const r = await executeQuery("idr", "compliance.elementsWithNoLocations",
    {locationId})
  return {value: formatNumberWithGrouping(r[0].Value)}
}

async function titleCallback(config: any) {
  return "Location: " + await getLocationCaption(config.params.locationId)
}

export default defineComponent({
  props: {config: Object},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())

    function chartClickCallback() {
      const locationId = props.config && props.config.params.locationId.value
      const drillDown = () => ({
        component: import('@/components/drilldowns/ComplianceElementsWithNoLocationDrillDown.vue'),
      })
      bus.$emit('chartPopup', {
        title: 'Compliance elements with no locations',
        component: drillDown,
        componentArgs: {
          locationId
        }
      })
    }

    return {dataFetcher, chartClickCallback, titleCallback}
  },
})
